import createReactComponent from '../createReactComponent';
export default createReactComponent(
  'chevron-down-right',
  'IconChevronDownRight',
  [['path', { d: 'M16 8v8h-8', key: 'svg-0' }]],
);
